export enum DowntimeDashboardQueryKey {
  StoppagesFailureTypes = 'stoppage-failure-types',
  StoppageCategoryTypesCount = 'stoppage-category-types-count',
  RcfaAvailability = 'rcfa-availability'
}
